import { createAsyncThunk } from '@reduxjs/toolkit'
import swalAlert from './swalAlert'

/**
 * Create Redux async action
 *
 * @public
 * @param {String} name Action name
 * @param {Function} service API call
 */
const createAsyncThunkMiddleware = (name, service) =>
  createAsyncThunk(name, async (args, thunkAPI) => {
    try {
      const res = await service(args)
      return res
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        swalAlert.error(error.response.data.message)
        return thunkAPI.rejectWithValue(error.response.data.message)
      }
      swalAlert.error(error.message)
      return thunkAPI.rejectWithValue(error.message)
    }
  })

export default createAsyncThunkMiddleware
